import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../Contexts/AuthContext";
import { IS_MOBILE_BUILD } from "../../utils/platform";

export default function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (currentUser) {
    return children;
  }

  // Send unauthenticated visitors to login; remember Jobs intent so they
  // land on /jobs after signing in.
  if (location.pathname.startsWith("/jobs")) {
    localStorage.setItem("fromWhere", "jobs");
    return <Navigate to="/login" replace />;
  }

  // The app has no marketing landing page to fall back to - "/" is My Resumes,
  // which is itself guarded, so sending anonymous users there would loop.
  if (IS_MOBILE_BUILD) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/" replace />;
}
